import { useFormStore } from '@/stores/form'
import router from '@/router'
import apiHelperService from '@/services'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'

const doNotify = (title, text, duration = 6000, group = 'error') => {
  notify(
    {
      group: group,
      title,
      text
    },
    duration
  )
}

const setDraftPayload = () => {
  const formStore = useFormStore()
  const data = {
    withException: false,
    deletedAttachments: formStore.extraMap.deletedAttachments,
    auditedAttachments: formStore.extraMap.auditedAttachments
  }
  const payload = removeEmptyValues(data)
  formStore.extraMap.formPayload = payload
}

function removeEmptyValues(obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key]
      if (
        value === null ||
        value === undefined ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0)
      ) {
        if (!obj.request) {
          delete obj[key]
        }
      }
    }
  }
  return obj
}

const saveRequestDraft = () => {
  const formStore = useFormStore()
  const formDraft = formStore.form.values
  if (checkValidatePersonInfo()) {
    if (!formDraft.gccClassCode && !formDraft.gccCategoryCode) {
      doNotify(i18n.global.t('ERRORS'), i18n.global.t('categuryMissing'), undefined, 'error')
      return false
    } else if (!formDraft.localMobile) {
      doNotify(i18n.global.t('ERRORS'), i18n.global.t('inValidLocalMobile'), undefined, 'error')
      return false
    } else if (!formDraft.passportNumber || !formDraft.passportTypeId) {
      doNotify(
        i18n.global.t('ERRORS'),
        i18n.global.t('newPassportDataEntryMsg'),
        undefined,
        'error'
      )
      return false
    } else {
      setDraftPayload()
      return true
    }
  }
}

const checkValidatePersonInfo = async () => {
  const formStore = useFormStore()
  const serviceTransactionId = router.currentRoute.value.params.serviceId
  const moduleParentReasonId = formStore.form.values?.gccClassCode
  const { identityNumber, personUnifiedNumber } = formStore.form.values
  try {
    const params = {
      moduleParentReasonId,
      personIdentityNumber: identityNumber,
      personUnifiedNumber,
      serviceTransactionId: serviceTransactionId || 573
    }
    const result = await apiHelperService.get(
      '/api/icaRequest/checkValidatePersonByUnifiedNumber',
      {
        params
      }
    )

    if (result && result.isValid !== true) {
      formStore.form.setValues({
        personUnifiedNumber: undefined,
        eidNumber: undefined,
        serviceTransactionId: null
      })
      doNotify(i18n.global.t('ERRORS'), i18n.global.t(result.validationMessage), undefined, 'error')
      return false
    } else {
      return true
    }
  } catch (error) {
    console.error('loadTransactionReasons', error)
  }
}

export default async function () {
  saveRequestDraft()
  return true
}
